// Route path constants
export const ROUTES = {
  // Auth
  LOGIN: '/login',
  
  // Common
  DASHBOARD: '/dashboard',
  SETTINGS: '/settings',
  
  // Admin Routes
  ADMIN_DASHBOARD: '/admin/dashboard',
  TEMPLATES: '/admin/templates',
  TEMPLATE_CREATE: '/admin/templates/create',
  TEMPLATE_VIEW: '/admin/templates/:id',
  TEMPLATE_EDIT: '/admin/templates/:id/edit',
  USER_MANAGEMENT: '/admin/users',
  PROMPTS: '/admin/prompts',
  CONFIG: '/config',
  
  // User Routes
  USER_DASHBOARD: '/user/dashboard',
  
  // Reviewer Routes
  REVIEWER_DASHBOARD: '/reviewer/dashboard',
  
  // Document Routes
  DOCUMENTS: '/documents',
  DOCUMENT_CREATE: '/documents/create',
  DOCUMENT_EDITOR: '/documents/:id/editor',
  
  // Legacy (keeping for backward compatibility)
  USERS: '/users',
};

// Helper to generate document editor route with ID
export const getDocumentEditorRoute = (documentId) => {
  return `/documents/${documentId}/editor`;
};

// Route configuration with metadata
export const ROUTE_CONFIG = [
  // Auth Routes
  {
    path: ROUTES.LOGIN,
    name: 'Login',
    isPublic: true,
    requiresAuth: false,
  },
  
  // Admin Routes
  {
    path: ROUTES.ADMIN_DASHBOARD,
    name: 'Admin Dashboard',
    isPublic: false,
    requiresAuth: true,
    allowedRoles: ['ADMIN'],
    module: 'admin',
  },
  {
    path: ROUTES.TEMPLATES,
    name: 'Template Management',
    isPublic: false,
    requiresAuth: true,
    allowedRoles: ['ADMIN'],
    module: 'admin',
  },
  {
    path: ROUTES.USER_MANAGEMENT,
    name: 'User Management',
    isPublic: false,
    requiresAuth: true,
    allowedRoles: ['ADMIN'],
    module: 'admin',
  },
  {
    path: ROUTES.PROMPTS,
    name: 'Prompt Management',
    isPublic: false,
    requiresAuth: true,
    allowedRoles: ['ADMIN'],
    module: 'admin',
  },
  {
    path: ROUTES.CONFIG,
    name: 'Configuration',
    isPublic: false,
    requiresAuth: true,
    allowedRoles: ['ADMIN'],
    module: 'admin',
  },
  
  // User Routes
  {
    path: ROUTES.USER_DASHBOARD,
    name: 'My Dashboard',
    isPublic: false,
    requiresAuth: true,
    allowedRoles: ['USER'],
    module: 'user',
  },
  
  // Reviewer Routes
  {
    path: ROUTES.REVIEWER_DASHBOARD,
    name: 'Review Dashboard',
    isPublic: false,
    requiresAuth: true,
    allowedRoles: ['REVIEWER'],
    module: 'reviewer',
  },
  
  // Document Routes (accessible by multiple roles)
  {
    path: ROUTES.DOCUMENTS,
    name: 'Documents',
    isPublic: false,
    requiresAuth: true,
    allowedRoles: ['ADMIN', 'USER', 'REVIEWER'],
    module: 'documents',
  },
  {
    path: ROUTES.DOCUMENT_CREATE,
    name: 'Create Document',
    isPublic: false,
    requiresAuth: true,
    allowedRoles: ['ADMIN', 'USER'],
    module: 'documents',
  },
  {
    path: ROUTES.DOCUMENT_EDITOR,
    name: 'Document Editor',
    isPublic: false,
    requiresAuth: true,
    allowedRoles: ['ADMIN', 'USER', 'REVIEWER'],
    module: 'documents',
  },
  
  // Common Routes
  {
    path: ROUTES.DASHBOARD,
    name: 'Dashboard',
    isPublic: false,
    requiresAuth: true,
    allowedRoles: ['USER', 'ADMIN', 'REVIEWER'],
  },
  {
    path: ROUTES.SETTINGS,
    name: 'Settings',
    isPublic: false,
    requiresAuth: true,
    allowedRoles: ['USER', 'ADMIN', 'REVIEWER'],
  },
  
  // Legacy Routes
  {
    path: ROUTES.USERS,
    name: 'User Management',
    isPublic: false,
    requiresAuth: true,
    allowedRoles: ['admin'],
  },
];

// Get route config by path
export const getRouteConfig = (path) => {
  return ROUTE_CONFIG.find(route => route.path === path);
};

// Check if user has access to route
export const hasRouteAccess = (path, userRole) => {
  const config = getRouteConfig(path);
  if (!config) return false;
  if (config.isPublic) return true;
  if (!config.allowedRoles) return true;
  return config.allowedRoles.includes(userRole);
};

// Get default route for role
export const getDefaultRouteForRole = (role) => {
  switch (role) {
    case 'ADMIN':
      return ROUTES.ADMIN_DASHBOARD;
    case 'USER':
      return ROUTES.USER_DASHBOARD;
    case 'REVIEWER':
      return ROUTES.REVIEWER_DASHBOARD;
    default:
      return ROUTES.DASHBOARD;
  }
};
